var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline bg-gray p-3"},[_c('div',{staticClass:"large-text-bold pb-10"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"small-text-regular"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }